import React, { useCallback } from 'react';

import { WizardFormData } from '@/sections/customerManagement/components/modals/AddCustomerModal/AddCustomerModal.types';
import { calculateSubscriptionDates } from '@/sections/customerManagement/utils';

export interface UseDateCalculationReturn {
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
}

interface UseDateCalculationProps {
  formData: WizardFormData;
  setFormData: React.Dispatch<React.SetStateAction<WizardFormData>>;
}

/**
 * Custom hook for managing subscription date calculations
 */
export const useDateCalculation = ({
  formData,
  setFormData,
}: UseDateCalculationProps): UseDateCalculationReturn => {
  const handleStartDateChange = useCallback(
    (date: string) => {
      if (!formData.customer_type || !date) {
        setFormData(prev => ({
          ...prev,
          subscription_start_date: date,
        }));
        return;
      }

      // Calculate dates based on business rules
      const calculation = calculateSubscriptionDates({
        customerType: formData.customer_type,
        requestedStartDate: date,
      });

      // Update form data
      setFormData(prev => ({
        ...prev,
        subscription_start_date: calculation.startDate,
        subscription_end_date: calculation.endDate,
      }));
    },
    [formData.customer_type, setFormData]
  );

  const handleEndDateChange = useCallback(
    (date: string) => {
      setFormData(prev => ({
        ...prev,
        subscription_end_date: date,
      }));
    },
    [setFormData]
  );

  return {
    handleStartDateChange,
    handleEndDateChange,
  };
};
